import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "job-rates-slot" }
const _hoisted_2 = { class: "m-bottom-15" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "job-rates-slot__min-price m-top-15" }
const _hoisted_5 = {
  key: 1,
  class: "c-secondary-black m-left-10"
}
const _hoisted_6 = {
  key: 2,
  class: "m-left-10"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "c-secondary-black" }, "Job minimum cost:")
], -1)
const _hoisted_8 = { class: "c-secondary-black m-left-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconsSubscription = _resolveComponent("IconsSubscription")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_ctx.JOB_TYPE_TITLE[_ctx.$props.type]), 1)
    ]),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$props.prices, (price, key, id) => {
        return (_openBlock(), _createElementBlock("li", { key: id }, [
          (key !== 'minimum_price')
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.PRICING_TITLE[key]) + ": ", 1),
                _createElementVNode("b", null, "$" + _toDisplayString(_ctx.getPrice(key, price)), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.typeMinimumPrice || _ctx.profile?.subscription?.plan === _ctx.SUBSCRIPTION_PLAN.free)
        ? (_openBlock(), _createBlock(_component_IconsSubscription, {
            key: 0,
            plan: _ctx.SUBSCRIPTION_PLAN.free
          }, null, 8, ["plan"]))
        : _createCommentVNode("", true),
      (_ctx.typeMinimumPrice && _ctx.profile?.subscription?.plan === _ctx.SUBSCRIPTION_PLAN.free)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Job minimum cost: $" + _toDisplayString(_ctx.$props.prices.minimum_price) + " (Free users only) ", 1))
        : _createCommentVNode("", true),
      (!_ctx.typeMinimumPrice)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$props.prices.minimum_price, (min, key, id) => {
              return (_openBlock(), _createElementBlock("li", { key: id }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.MINIMUM_PRICE_TITLE[key]) + ": $" + _toDisplayString(min) + "/record ", 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}